module.exports = __webpack_public_path__ + "img/oil-sq.07bdc2a9.svg";